import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  public errorMessage: string = '';
 
  constructor(private router: Router) { }
 
  public handleError = (error: HttpErrorResponse) => {

    if(error.status === 500 || error.status === 501 || error.status === 502 || error.status === 503 ||  error.status === 504 ){
      this.handle500Error(error)
    }
    else{
      this.handleOtherError(error);
    }
  }

  handleOtherError(error: HttpErrorResponse) {
   if(error.status != undefined || error.status != undefined ){
     console.log("in other")
    this.router.navigate([error]);  
   }
  }

  handle500Error(error: HttpErrorResponse) {
    if(error.error.message != null && error.error.statusCode != null){
      this.router.navigate(['not-found',error.error.message,error.error.statusCode])
     }else{
      this.router.navigate(['error',error.status]); 
    }
  }


}
